import { createSvgIcon } from "@mui/material/utils";

/**
 * User icon.
 *
 * ![UserIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi44OCAtMi44OCAyOS43NiAyOS43NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHN0eWxlPSJiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czo0cHgiPjxwYXRoIGQ9Ik0yMiAyMVYxOUMyMiAxNy4xMzYyIDIwLjcyNTIgMTUuNTcwMSAxOSAxNS4xMjZNMTUuNSAzLjI5MDc2QzE2Ljk2NTkgMy44ODQxNSAxOCA1LjMyMTMxIDE4IDdDMTggOC42Nzg2OSAxNi45NjU5IDEwLjExNTkgMTUuNSAxMC43MDkyTTE3IDIxQzE3IDE5LjEzNjIgMTcgMTguMjA0NCAxNi42OTU1IDE3LjQ2OTNDMTYuMjg5NSAxNi40ODkyIDE1LjUxMDggMTUuNzEwNSAxNC41MzA3IDE1LjMwNDVDMTMuNzk1NiAxNSAxMi44NjM4IDE1IDExIDE1SDhDNi4xMzYyMyAxNSA1LjIwNDM1IDE1IDQuNDY5MjcgMTUuMzA0NUMzLjQ4OTE1IDE1LjcxMDUgMi43MTA0NiAxNi40ODkyIDIuMzA0NDggMTcuNDY5M0MyIDE4LjIwNDQgMiAxOS4xMzYyIDIgMjFNMTMuNSA3QzEzLjUgOS4yMDkxNCAxMS43MDkxIDExIDkuNSAxMUM3LjI5MDg2IDExIDUuNSA5LjIwOTE0IDUuNSA3QzUuNSA0Ljc5MDg2IDcuMjkwODYgMyA5LjUgM0MxMS43MDkxIDMgMTMuNSA0Ljc5MDg2IDEzLjUgN1oiIHN0cm9rZT0iIzEwMTgyOCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD48L3N2Zz4=)
 */
const UserIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "User"
);

export default UserIcon;
